module.exports = __webpack_public_path__ + "static/sport/banner4.6497a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner4.png
// module id = bbHY
// module chunks = 0